import { configureStore } from "@reduxjs/toolkit";
import feedbackSlice from "./feedback";
import imagesSlice from "./images";
import image_upload_slice from "./image_upload";
import image_retake_upload_slice from "./image_upload_retake";

import video_upload_slice from "./video_upload"
import { user_slice } from "./user"

const store = configureStore({
  reducer: {
    feedbackStore: feedbackSlice,
    imagesStore: imagesSlice,
    imageUploadStore: image_upload_slice,
    imageretakeUploadStore: image_retake_upload_slice,
    videouploadStore: video_upload_slice,
    user_slice: user_slice.reducer

  },
});


export default store;